import axios from 'axios'
import { buildAvailabilityUrl } from './buildAvailabilityUrl'

export default async function zipLogic(zipCode) {
  try {
    const datasetUrl = `https://dm.clear.link/api/datasets/hughesnet-ziplist/find?search[Zip]=${zipCode}`

    const zipSubmissionData = await axios.get(datasetUrl, {
      headers: {
        'X-Api-Key': '358ea773800344e78f353d315727621b',
      },
    })

    const zipData = zipSubmissionData?.data?.dataset?.data
      ? zipSubmissionData?.data?.dataset?.data[0]
      : null

    return buildAvailabilityUrl(zipData?.City?.toLowerCase(), zipData?.State)
  } catch (err) {
    console.error(err)  
    return null
  }
}
